export default "__VITE_ASSET__Ce01PyAx__"